var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M19,24H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H19a5.006,5.006,0,0,1,5,5V19A5.006,5.006,0,0,1,19,24ZM5.652,5.437H5.645a.145.145,0,0,0-.114.057.147.147,0,0,0-.026.124l1.583,6.409a.1.1,0,0,0,.005.022l1.58,6.4a.147.147,0,0,0,.1.106.157.157,0,0,0,.04.005.148.148,0,0,0,.1-.041l9.537-9.175a.145.145,0,0,0,.041-.14.147.147,0,0,0-.1-.106l-3.164-.912a.149.149,0,0,0-.068-.019l-6.237-1.8a.144.144,0,0,0-.074-.022L5.686,5.442A.11.11,0,0,0,5.652,5.437ZM8.9,18.134v0L8.21,15.355l2.756.789L8.9,18.133Zm2.109-2.282h0l-2.665-.765,2-1.93L11,15.85Zm.3-.03v0l-.665-2.686,2.66.768L11.3,15.821Zm-3.2-.914v0l-.665-2.694,2.665.769-2,1.926Zm5.278-1.288h0l-2.71-.782L12.7,10.878l.675,2.74Zm.284-.07v0l-.675-2.739,2.716.779-2.039,1.96Zm-3.432-.836h0L7.516,11.93,9.554,9.969l.675,2.742Zm.274-.124v0L9.838,9.895l2.668.766-2,1.927ZM7.313,11.72v0L6.636,8.98l2.715.778-2.037,1.96Zm8.429-.427h0l-2.665-.764,2-1.93.665,2.692Zm.3-.026v0l-.674-2.732,2.705.778-2.03,1.954Zm-3.46-.893h0L9.923,9.613l1.993-1.919.66,2.679Zm.289-.052v0l-.665-2.7,2.668.769-2,1.929ZM9.432,9.476h0L6.764,8.711l2-1.929.665,2.692Zm.284-.071v0L9.052,6.717l2.66.766L9.718,9.4Zm-3.191-.87v0L5.849,5.794l2.711.78L6.526,8.534Z",
    fill: "#ffb400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/Three.9adde193dc0a51b99a61d18bd0dfce91.svg";
export { ForwardRef as ReactComponent };